import React, {forwardRef, useEffect, useImperativeHandle, useState, useReducer, useLayoutEffect, useRef} from "react";
import StarterKit from "@tiptap/starter-kit";
import { Color } from "@tiptap/extension-color";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import Paragraph from "@tiptap/extension-paragraph";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
// import {Underline} from "./underline";
import Highlight from "@tiptap/extension-highlight";
import Placeholder from "@tiptap/extension-placeholder";
import {useEditor, EditorContent, BubbleMenu, ReactNodeViewRenderer} from "@tiptap/react";
import { Col, ColorPicker, Divider, Dropdown, Popover, Row, Select, Space, message } from "antd";
import html2canvas from "html2canvas";
import { noteServer, getNoteName } from "@/common/notesServer";
import style from "./index.module.less";
import "./editor.less";
import './x.css'
import {getBlockMenu} from './BlockMenu/BlockMenu'
import FontSize from 'tiptap-extension-font-size'
import ImageT from '@tiptap/extension-image'
import Image from './imgResize'
// import Link from '@tiptap/extension-link'
import Link from './extension-link/src/index'
import HorizontalRule from '@tiptap/extension-horizontal-rule'
import Blockquote from '@tiptap/extension-blockquote'
import TaskItem from './task-item'
import TaskList from '@tiptap/extension-task-list'
import LinkPage from './Link'
import { ImagePaste, fileToBase64 } from './ImagePaste'
// import SearchNReplace from "@sereneinserenade/tiptap-search-and-replace";
import SearchNReplace from "./Search/plugin";
import Background from 'tiptap-extension-background-color'

import SearchBox from './Search'
import { AlignTextCenter, Down, Strikethrough, TextBold, TextItalic, TextUnderline, Up, Link as LinkIcon } from "@icon-park/react";
import ColorPickers from './ColorPicker'
// import {CustomStrike} from './clipboardTextParser'
import {Extension, markPasteRule, NodePos,mergeAttributes,findParentNode, InputRule} from '@tiptap/core'
import ImgAction from './ImgAction'
// import { PasteRules } from 'tiptap-extensions'

import { imgServer } from './imgServer'
import { Indent } from './indent'
import * as model from '@model'

import { pdfAtom } from '@/state'
import { useAtom } from "jotai";

import { FullScreen } from '@/state';
import { DownOutlined } from "@ant-design/icons";

import { Decoration, DecorationSet } from "@tiptap/pm/view"
import i18n, {t} from "i18next";
import {fontFamily} from "html2canvas/dist/types/css/property-descriptors/font-family";
import {FontFamily} from "@tiptap/extension-font-family";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {
  CARD_MAX_PASTE_SIZE, DEFAULT_TIPTAP_FONT_SIZE,
  EVENT_CLOSE_IMAGE_ACTION, EVENT_FAVIRIATE_CHANGE,
  EVENT_NOTE_READONLY_STATUS,
  EVENT_NOTE_READONLY_STATUS_1,
  EVENT_REFRESH_DEEPLINK_TITLE, EVENT_REFRESH_EDIT_CARD, EVENT_REFRESH_EDIT_CARD_NEW, EVENT_REFRESH_FAVOR,
  EVENT_REFRESH_INFO,
  EVENT_REFRESH_LIBRARY_LIST, EVENT_REFRESH_RECENTS, EVENT_RENAME_LIBRARY_ITEM,
  EVENT_SAVE_CARD,
  EVENT_SYNC_NOTE_DATA,
  EVENT_SYNC_REFRESH_DRAW_CARDEDIT, EVENT_UPDATE_HIGHLIGHT_ANNO,
  EVENT_UPDATE_NOTE, EVENT_UPDATE_TAG,
  FROM_HISTORY,
  FROM_JOURNAL,
  FROM_LIBRARY,
  FROM_PAGE_CARD,
  FROM_PDF, FROM_SHARE_CARD,
  IMPORT_FILE_MODE_ASKME, IMPORT_FILE_MODE_IMPORTMODE,
  KEY_CARD_CURSOR_POS_, KEY_FILE_DIR,
  KEY_FILE_IMPORT_MODE, KEY_GLOBAL_INFO_VISIBLE,
  KEY_MACHINEID,
  LASTEST_NOTE_DOC,
  LEFT_MENU_WIDTH,
  LINK_INFO_TYPE_LIBRARY,
  LINK_INFO_TYPE_PAGE,
  LINK_INFO_TYPE_PROJECT,
  MAP_WEEK_FULL, MAX_IMAGE_FILE_SIZE, MAX_Z_INDEX
} from "@/Const";
import {APP_WEB, isWeb} from "@/electron_interactive";
import {
  createCopyLink,
  decodeDeeplink,
  extFromMineType,
  firstLetterUpper,
  getImagePathWithTheme,
  getSelectionCoords,
  imgPathPerfix,
  isCardEmpty,
  isDarkMode,
  isDeepLink,
  removeHtmlTags,
  getYouTubeThumbnailUrl,
  sleep,
  isInSidebar,
  isInPageCard,
  generateUUID2,
  isImage,
  getJournalName,
  getImagePathWithThemeSvg,
  getImagePathWithSvg,
  isString,
  isInDraw,
  migrateInlineCodeToOfficial,
  getFileNameExt,
  getFileName,
  isInPageLibrary,
  isInPageTag,
  isInPageTask,
  replaceLatexInParagraph, isInPageCardOrJournal, isInJournal
} from "@/utils";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import RightMenu from '@/components/RightMenu'
import global from "@/global";
import CountWords from "@/components/EditorV2/CountWords";
import {Export} from "@tiptap-pro/extension-export";

import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import css from 'highlight.js/lib/languages/css';
import js from 'highlight.js/lib/languages/javascript';
import ts from 'highlight.js/lib/languages/typescript';
import html from 'highlight.js/lib/languages/xml';
import CodeBlockComponent from './CodeBlock3';
import {lowlight} from "lowlight";
import {Fragment, Node, Slice} from "prosemirror-model";
import DeeplinkNode from "@/components/Deeplink/DeeplinkNode";
import {
  insertCopyLinkToCard, insertDeeplinkToCard, insertFileToLibrary, isInSingleFloatWindow
} from "@/Utility";
import {batchCardHighlight, batchUpdateCard, getCardById, removeCardImage, renameCard, renameCardById, updateCard} from "@model/card";
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import CustomTableCell from "@/components/EditorV2/TableCell/tableCell";
import {UniqueID} from "@tiptap-pro/extension-unique-id";
import Focus from '@tiptap/extension-focus'
import Gapcursor from '@tiptap/extension-gapcursor'
import LibraryInfos from "@/views/Library/LibraryInfos";
import {editDoc} from "@model/doc";
import latexBlock from './latexMath/latexBlock.ts'
// import Youtube from '@tiptap/extension-youtube'
import {Youtube} from "@/components/EditorV2/extension-youtube";
import HardBreak from '@tiptap/extension-hard-break'

import Mathematics from '@tiptap-pro/extension-mathematics'
import 'katex/dist/katex.min.css'
import RenderCustomTable from "@/components/EditorV2/Table/RenderCustomTable";
import ListKeymap from '@tiptap/extension-list-keymap'
import {PopupCardPlus} from "@/components/Plus/PopupCardPlus";

import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";

import SideBarFold from "@/components/EditorV2/SideBarFold/SideBarFold"
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'

import HighlightPicker from "@/components/EditorV2/HighlightPicker/HighlightPicker";
import {getAllHighlightContent} from "@/Utility0";
import { Plugin,PluginKey,NodeSelection, TextSelection } from 'prosemirror-state';
import TurnNewCard from "@/components/EditorV2/TurnNewCard/TurnNewCard";

import {
  handleBackspace,
  handleClipboard, handlePaste, handleShiftTab, handleTab,
  handleTransformPastedHTML,
  handleTransformPastedText
} from "@/components/EditorV2/TiptapCommonHandle";
import {Table} from "@tiptap/extension-table";
import Global from "@/global";
import GlobalDragHandle from './drag/index'
import latexInline from './latexInline/latexInline.ts'
import {getListItemExtend} from "@/components/EditorV2/EditorExtensions/ListItemExtend";
import {getHeadingExtend} from "@/components/EditorV2/EditorExtensions/HeadingExtend";
import CodeInlie from '@tiptap/extension-code'
import {getBubblletListExtend} from "@/components/EditorV2/EditorExtensions/BulletListExtend";
import {defaultBlockMenuItems} from "@/components/EditorV2/BlockMenu/default-items";
import {
  getBoldExtension,
  getHyperlinkExtension,
  getItalicExtension, getOperatorAlignExtension, getOperatorOnSpaceOrEnter,
  getStrikeExtension
} from "@/components/EditorV2/TiptapTiptapExtension";
import InputNumberExt from "@/common/InputNumberExt";

lowlight.registerLanguage('html', html);
lowlight.registerLanguage('css', css);
lowlight.registerLanguage('js', js);
lowlight.registerLanguage('ts', ts);

let timer:any = null

/** 编辑器状态 0 未初始化 1 已初始化 2 已做改动，需要保存 */
let isEdited = 0

//第一次设置的数据，不要同步到别的地方保存....
let mIsFristSetData = false;

/** 文档编辑器 */
export type TEditorRef = {
  save: () => Promise<{
    /** 略缩图 */
    img: string;
    /** 文档内容 */
    doc: string;
    name: string
  }>;
  rename: () => void,
  onForceUpdate:()=>void,
};

const Editor = forwardRef((props: { data?: any,from?:string,subFrom?:string,source?:any,onSaveData?:any,onEmptyData?:any,onInitComplete?:any,onUpdate?:any}, ref) => {

  /** 标题 */
  const [title, setTitle] = useState<string>('')

  /** 是否在生成图片 */
  const [draw, setDraw] = useState<boolean>(false)
  const [background, setBackground] = useState<string>('#dae9f8')

  const [pos, setPos] = useState<[boolean, number]>([false, 0])
  const [hasTitleEmpty, setHasTitleEmpty] = useState(isInSingleFloatWindow()?true:false);
  const mHasTitleEmpty = useRef(false);
  // const forceUpdate = useReducer((x) => x + 1, 0)[1]

  const [, updateState] = useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [isShowLink, setIsShowLink] = useState(false);
  const [isExpandInfo, setIsExpandInfo] = useState(false);
  const libraryInfoRef = useRef(null);

  const [modalHeight, setModalHeight] = useState(0);
  const [marginJournal,setMarginJournal] = useState('0px');
  const [paddingJournal,setPaddingJournal] = useState('0px');

  const [isShowTextBar, setIsShowTextBar] = useState(true);

  const dataRef = useRef<any>(null);
  const dataRef1 = useRef<any>(null);
  const titleRef = useRef<any>(null);
  const sideBarRef = useRef(null);

  const sideBarStatus = useRef(0);

  /** 是否在导出pdf */
  const isPdfAtom = useAtom(pdfAtom)[0];

  const [fullScreen, setFullScreen] = useAtom(FullScreen);
  const [currentFontSize, setCurrentFontSize] = useState<number | string>(DEFAULT_TIPTAP_FONT_SIZE);

  const editorRef = useRef<any>(null);
  const txtTitleRef = useRef<any>(null);
  const divTitleRef = useRef<any>(null);
  //同步更新时间
  const mSyncUpdateTime = useRef<any>(0);

  let selectedDragNode:any;
  let cleanCopyDomFragment;
  const editorContentRef = useRef(null);

  const uuid = useRef(generateUUID2());
  const mIsSimpleRefresh = useRef(false);

  const onForceUpdate = () => {
    forceUpdate();
  }


  /**
   * 这里是更新回调设置..---
   * @param data
   */
  window.cardUpdateCallbacks[uuid.current] = (data)=>{
    if (data.id == props.data?.id){
      //设置标题---一样的才同步....
      setTitle(data.name);
      if (editorRef.current){
        editorRef.current.commands.setContent(data.doc);
      }
    }
  }

  let extensions = [
    StarterKit.configure({
      // history:false,
    }),
    // 运算符垂直对齐：通过 Decoration 给 + - * / 包裹 span，配合 editor.less 中的 CSS 变量控制偏移
    getOperatorAlignExtension(),
    getOperatorOnSpaceOrEnter(),
    // InlineCodeMark,
    CodeInlie,
    getListItemExtend(),
    OrderedList.extend({
      addAttributes() {
        return {
          ...this.parent?.(), // 保留原有的属性
          blockHighlight: {
            default: false,
          },
          noteText: {
            default: ''
          },
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          },
        };
      },
    }),
    getBubblletListExtend(),
    Youtube.extend({
      addAttributes() {
        return {
          ...this.parent?.(), // 保留原有的属性
          highlightImgUrl: {
            default: '',
          },
          noteText: {
            default: ''
          },
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          },
        };
      },
    }),
    // ListKeymap,

    HardBreak.extend({
      addKeyboardShortcuts() {
        return {
          "Mod-z":()=>{
            const history = editor.extensionStorage.history;
            console.log(history)
          },
          "Mod-e":()=>{
            //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
            editor.chain().focus().toggleCode().run();
            return true;
          },
          "Mod-k":()=>{
            if (editor.state.selection.from != editor.state.selection.to){
              showLink();
            }else{
              //显示全局的搜索.
              window.showDialogGlobalSearch();
            }
          },
          "Mod-Shift-e":()=>{
            const selectedText = editor.state.doc.textBetween(
                editor.state.selection.from,
                editor.state.selection.to,
                "\n"  // 节点分隔符
            );
            if (selectedText){
              editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
            }else{
              editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
            }

            return true;
          },
          "Mod-E":()=>{
            //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
            editor.chain().focus().toggleCode().run();
            return true;
          },
          "Mod-K":()=>{
            showLink();
          },
          "Mod-Shift-E":()=>{
            const selectedText = editor.state.doc.textBetween(
                editor.state.selection.from,
                editor.state.selection.to,
                "\n"  // 节点分隔符
            );
            if (selectedText){
              editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
            }else{
              editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
            }

            return true;
          },
          Enter: () => {
            // setTimeout(()=>{
            //   window.hookATags();
            // },100)

            const divCustomDrag = document.querySelector(".drag-handle");
            if(divCustomDrag){
              divCustomDrag.style.display = "none";
            }

            const { from, to } = editorRef.current?.state.selection;
            const resolvedPos = editorRef.current?.state.doc.resolve(from);
            // 获取当前节点
            const currentNode = resolvedPos.node();
            const parentNode = resolvedPos.node(resolvedPos.depth - 1);
            const grandNode = resolvedPos.node(resolvedPos.depth - 2);
            const nodeStart = resolvedPos.start(resolvedPos.depth);
            const nodeEnd = resolvedPos.end(resolvedPos.depth);

            if (currentNode.type.name === 'paragraph' && nodeEnd === from && from === to && parentNode.type.name === 'listItem' && parentNode.attrs.listFold === true) {
              // 插入新的listitem
              const resolvedPos1 = editor.state.doc.resolve(from);
              const parentResolvedPos = editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
              const parentFrom = parentResolvedPos.start(parentResolvedPos.depth);
              const parentTo = parentResolvedPos.end(parentResolvedPos.depth);
              const listItemType = parentNode.type

              const paragraph = editor.state.schema.nodes.paragraph.create()
              const newListItem = listItemType.create(null, paragraph)
              const tr = editor.state.tr.insert(parentTo, newListItem)
              const resolvedPos = tr.doc.resolve(parentTo + 1)
              tr.setSelection(TextSelection.near(resolvedPos))
              editor.view.dispatch(tr.scrollIntoView())
              // debugger
              return true
            }
            if (resolvedPos.parentOffset === 0 && currentNode.type.name === 'paragraph') {
              setTimeout(() => {
                const { from, to } = editorRef.current?.state.selection;
                const resolvedPos = editorRef.current?.state.doc.resolve(from);
                // 获取下一个节点
                const node = resolvedPos.node();
                let tempID= node.attrs.id
                node.attrs.id=currentNode.attrs.id
                currentNode.attrs.id=tempID

              }, 100);
            }
            return false;
          },
          /*
          Backspace: () => {
            // 取消高亮
            editorRef.current.commands.unsetHighlight();
            setTimeout(()=>{
              window.hookATags();
            },100)

            const { state,view } = this.editor;
            const { selection } = state;
            const { from, to } = this.editor.state.selection;
            const resolvedPos = this.editor.state.doc.resolve(from);
            // 获取当前节点
            const currentNode = resolvedPos.node();

            // 获取当前节点的起始位置
            const nodeStart = resolvedPos.start(resolvedPos.depth);
            const parentNode = resolvedPos.node(resolvedPos.depth - 1);
            const grandNode = resolvedPos.node(resolvedPos.depth - 2);
            const grandGrandNode = resolvedPos.node(resolvedPos.depth - 3);

            const grandResolvedPos = this.editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 2));
            const grandResolvedPosFrom = grandResolvedPos.start(grandResolvedPos.depth);
            const isEmptyParagraph = currentNode.type.name === 'paragraph' && currentNode.content.size === 0;
            if (from === to && from === 1) {
              if (txtTitleRef.current && isEmptyParagraph) {
                const tr = state.tr.deleteRange(0, currentNode.nodeSize);
                view.dispatch(tr);
                const length = txtTitleRef.current.value.length;
                txtTitleRef.current.focus();
                txtTitleRef.current.setSelectionRange(length, length);
              }
            }

            //这里增加一个删除？？？？？？？？？？？？？？？？
            const doc = editorRef.current.state.doc;
            let preNode = null;
            doc.descendants((node,pos)=>{
              if (node.attrs.id == currentNode.attrs.id){
                return false;
              }
              preNode = node;
              return true;
            })
            if (preNode && (preNode.type?.name == 'deeplink' || preNode.type?.name == 'image')){
              editorRef.current.commands.deleteRange({from:from-1,to:to});
              if (preNode.type?.name == 'image'){
                if (preNode.attrs.src?.startsWith('atom://')){
                  var reg = new RegExp(preNode.attrs.src,'gi');
                  const matchs = editorRef.current.getHTML().match(reg);
                  if (matchs && matchs.length <= 1){
                    removeCardImage(preNode.attrs.src.replace('atom://',''))
                  }
                }
              }
              return;
            }


            if (currentNode.type.name === 'paragraph' && selection.$from.pos === nodeStart && currentNode.attrs?.indent > 0 && parentNode.type.name !== 'taskItem' && parentNode.type.name !== 'listItem') {
              this.editor.commands.outdent()
              return true
            } else if (currentNode.type.name === 'paragraph' && (selection.$from.pos === nodeStart) && (parentNode.type.name === 'taskItem' || parentNode.type.name === 'listItem')) {
              // 全选情况下
              if (((selection.to - selection.from) === (grandNode.nodeSize - 6) || (selection.to - selection.from) === (parentNode.nodeSize - 4)) && selection.from !== selection.to) {
                return false;
              }
              const resolvedPos1 = this.editor.state.doc.resolve(to);
              const currentNode1 = resolvedPos1.node();
              const parentNode1 = resolvedPos1.node(resolvedPos1.depth - 1);

              const parentResolvedPos = this.editor.state.doc.resolve(resolvedPos1.start(resolvedPos1.depth - 1));
              const from3 = parentResolvedPos.start(parentResolvedPos.depth);
              const to3 = parentResolvedPos.end(parentResolvedPos.depth);

              const parentResolvedPos2 = this.editor.state.doc.resolve(resolvedPos.start(resolvedPos.depth - 1));
              const from4 = parentResolvedPos2.start(parentResolvedPos2.depth);
              const to4 = parentResolvedPos2.end(parentResolvedPos2.depth);
              // 完全选中多行情况下且为嵌套list
              if (from4 + 1 === from && to3 - 1 === to && from !== to) {
                // 如果是嵌套list的第一层
                if (from === to && ['listItem', 'taskItem'].includes(grandGrandNode.type.name) && grandResolvedPosFrom + 2 === from) {
                  this.editor.commands.deleteRange({ from: grandResolvedPosFrom-2, to: from })
                  return true;
                }
                this.editor.commands.deleteRange({ from: from, to: to })
                return true;
              }


              if (parentNode.type.name === 'taskItem') {
                // console.log('---1---');
                this.editor.chain().focus().toggleTaskList().run()
                // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                //   this.editor.commands.deleteRange({ from: selection.from - 1, to: selection.to })
                // }
              } else if (parentNode.type.name === 'listItem' && grandNode.type.name === 'bulletList') {
                // console.log('---2---');
                this.editor.chain().focus().toggleBulletList().run()
                // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                //   console.log('----asdasdasdasd',selection.from,selection.to);
                //   this.editor.commands.deleteRange({ from: selection.from-1, to: selection.to })
                // }
              } else if (parentNode.type.name === 'listItem' && grandNode.type.name === 'orderedList') {
                // console.log('---3---');
                this.editor.chain().focus().toggleOrderedList().run()
                // if(selection.$from.pos - 1 === nodeStart && currentNode.textContent.includes("\u200B")){
                //   this.editor.commands.deleteRange({ from: selection.from - 1, to: selection.to })
                // }
                editorRef.current.view.state.doc.descendants((node, pos) => {
                  const from = pos;
                  const to = pos + node.nodeSize;
                });
              }
              return true
            }
            else {
              setTimeout(()=>{
                try{
                  const { state, view } = this.editor;
                  const { dispatch } = view;
                  const { doc } = state;
                  // 合并两个numberList
                  const lastNodePos = from - 2;
                  let nextNodePos = from + 2;
                  if (nextNodePos > to){
                    nextNodePos = to;
                  }

                  const lastNodeResolved = doc.resolve(lastNodePos);
                  const nextNodeResolved = doc.resolve(nextNodePos);

                  const lastNode = lastNodeResolved.node();
                  const nextNode = nextNodeResolved.node();
                  if (lastNode.type.name === 'orderedList' && nextNode.type.name === 'orderedList') {
                    const tr = state.tr;

                    // Find the position where the nextNode starts
                    const nextNodeStart = nextNodeResolved.start();

                    nextNode.content.content.forEach((child: Node, offset: number) => {
                      tr.insert(from - 4, child);
                    });
                    tr.delete(nextNodeStart - 1, nextNodeStart + nextNode.nodeSize);

                    if (dispatch) {
                      dispatch(tr);
                      editorRef.current.commands.focus(editorRef.current.state.selection.from - 0)
                    }
                  }
                }catch (e){
                  console.log(e)
                }
              },10)

              return false;
            }
          }
          */
          // 不改底层的版本
          Backspace: () => {
            const { from, to } = editorRef.current.state.selection;
            if (editorRef.current.isEmpty || (from == to && from <= 1)){
              //标题获取焦点
              if (!mHasTitleEmpty.current){
                txtTitleRef.current?.focus();
                // return true;//不要返回了，影响下面的.
              }
            }
            // 取消高亮
            return handleBackspace(editorRef.current,txtTitleRef);
          },
          Tab: () => {
            return handleTab(editorRef.current);
          },
          'Shift-Tab': () => {
            return handleShiftTab(editorRef.current);
          }
        }
      }
    }),
    // Mathematics.configure({
    //   // regex: /\&\&([^\&]*)\&\&/gi
    // }),
    latexInline,
    latexBlock,
    UniqueID.configure({
      types: ['tableRow', 'taskList', 'paragraph','deeplink', 'image', 'blockquote', 'bulletList', 'orderedList', 'horizontalRule', 'youtube', 'table', 'highlight', 'latexBlock'],
      filterTransaction: transaction => {
        return !transaction.getMeta('preventUpdate')
      }
    }),
    Focus.configure({
      className: 'has-focus',
      mode: 'deepest',
    }),
    Gapcursor,
    Text,
    TextStyle,
    Color,
    getHeadingExtend(),
    Paragraph.extend({
      addAttributes() {
        return {
          ...this.parent?.(),
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          },
        };
      },
    }),
    Highlight.configure({ multicolor: true }).extend({
      addAttributes() {
        return {
          ...this.parent?.(),
          id: {
            default: crypto.randomUUID()
          },
          noteText: {
            default: '',
          },
        };
      },
      addCommands() {
        return {
          ...this.parent?.(),
          setHighlightId: (id,from) =>async  ({ tr, state, dispatch }) => {
            // 改变id后立即渲染到页面中
            const resolvedPos = state.doc.resolve(from);
            const currentNode = resolvedPos.node().content.content[0];
            const currentMark = currentNode.marks[0];

            // 创建新的 mark，只更新 id
            const newMark = currentMark.type.create({
              ...currentMark.attrs,
              id: id
            });

            // 替换 mark
            const transaction = tr.removeMark(from, from + currentNode.text.length, currentMark)
                .addMark(from, from + currentNode.text.length, newMark);

            if (dispatch) {
              dispatch(transaction);
            }
            return true;
          }
        };
      }
    }),
    TextAlign.configure({
      types: ["heading", "paragraph"],
    }).extend({
      addKeyboardShortcuts() {
        return{
          "Mod-Shift-e":()=>{
            return false;
          },
          "Mod-Shift-E":()=>{
            return false;
          },
        }
      }
    }),
    Underline,
    PopupCardPlus,
    Placeholder.configure({
      placeholder: '',
    }),
    FontSize,
    Indent,
    Link.configure({
      protocols: ['noteey', 'noteeditor'],
      autolink: false,
      linkOnPaste: false,
      openOnClick: true
    }).extend({
      addAttributes() {
        return {
          ...this.parent?.(),
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          }
        }
      }
    }),
    ImageT.extend({
      addAttributes() {
        return {
          ...this.parent?.(),
          noteText: {
            default: '',
          },
        };
      }
    }),
    Background,
    Image.configure({
      allowBase64: true
    }),
    getHyperlinkExtension((szNoteId:any)=>{
      if (dataRef.current?.id != szNoteId){
        window.closeDialogCard(dataRef.current);
      }
    }),
    SearchNReplace.configure({
      searchResultClass: "search-result", // class to give to found items. default 'search-result'
      caseSensitive: false, // no need to explain
      disableRegex: false, // also no need to explain
    }),
    ImagePaste.configure({
      fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
      disableImagePaste: false,
      render: () => {
        return {
          onImagePaste: files => {
            files.forEach(file => {
              if (file.size > MAX_IMAGE_FILE_SIZE){
                const id = crypto.randomUUID();
                const szFileName = id +'.' + extFromMineType(file.type);
                ipcInvoke('resize-image-file',{filePath:file.path,name:szFileName,type:file.type,toLocal:true})?.then((szFilePath)=>{
                  editorRef.current?.chain().focus().setImage({src: 'atom://' +szFileName}).run()
                  editorRef.current?.commands.blur()
                })
              }else{
                fileToBase64(file).then(r => {
                  const id = crypto.randomUUID();
                  model.addImg(id, r)
                  editorRef.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                  editorRef.current?.commands.blur()
                })
              }

              // fileToBase64(file).then(r => {
              //   const id = crypto.randomUUID();
              //   model.addImg(id, r)
              //   editorRef.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
              //   editorRef.current?.commands.blur()
              // })
            });
          },
          onDisabledImagePaste: text => {
            console.log('text: ', text);
            // add text to editor if you want, or display an error/upselll message
          },
          // onImageDrop: files => {
          //   files.forEach(file => {
          //     fileToBase64(file).then(r => {
          //       const id = crypto.randomUUID();
          //       model.addImg(id, r)
          //       window.GEditor.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
          //       window.GEditor.commands.blur()
          //     })
          //   });
          // },
        };
      },
    }),
    TaskList.extend({
      addAttributes() {
        return {
          ...this.parent?.(), // 保留原有的属性
          blockHighlight: {
            default: false,
          },
          noteText: {
            default: ''
          },
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          }
        };
      },
    }),
    TaskItem.configure({
      nested: true,
    }),
    HorizontalRule.extend({
      addAttributes() {
        return {
          ...this.parent?.(), // 保留原有的属性
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          }
        };
      },
    }),
    Blockquote.extend({
      addAttributes() {
        return {
          ...this.parent?.(), // 保留原有的属性
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          }
        };
      },
    }),
    FontFamily,
    CodeBlockLowlight.extend({
      addNodeView() {
        return ReactNodeViewRenderer(CodeBlockComponent);
      },
      addAttributes() {
        return {
          id: {
            default: () => {
              return crypto.randomUUID()
            },  // 生成唯一的 ID，只有第一次创建时生成
            parseHTML: element => {
              return (
                  element?.lastElementChild?.getAttribute("id") ||
                  element?.getAttribute("data-id") ||
                  crypto.randomUUID()
              );
            },
            renderHTML: (attributes) => {
              if (!attributes.id) return {};
              return { "data-id": attributes.id };
            },
          },
          ifhidden: {
            default: false,
            renderHTML: attributes => {
              if (attributes.ifhidden === undefined) {
                return {};
              }
              return {
                'ifhidden': attributes.ifhidden,
              };
            },
          },
          language: {
            default: 'Auto'
          }
        };
      }
    }).configure({lowlight}),
    DeeplinkNode,
    RenderCustomTable.configure({
      resizable: true,
      lastColumnResizable:true,
      allowTableNodeSelection: true,
    }),
    TableHeader,
    CustomTableCell,
    TableRow,
      getBoldExtension(),
      getItalicExtension(),
      getStrikeExtension()
  ];

  if (!isWeb()){
    extensions.push(
        Export.configure(window.IPC.getConvertToken()),
    )
  }

  if (props.from != FROM_HISTORY) {
    if (!isInSingleFloatWindow()){
      extensions.push(
          getBlockMenu(),
      )
    }

    extensions.push(
        GlobalDragHandle.configure({
          dragHandleWidth: 20, // default

          // The scrollTreshold specifies how close the user must drag an element to the edge of the lower/upper screen for automatic
          // scrolling to take place. For example, scrollTreshold = 100 means that scrolling starts automatically when the user drags an
          // element to a position that is max. 99px away from the edge of the screen
          // You can set this to 0 to prevent auto scrolling caused by this extension
          scrollTreshold: 100, // default

          // The css selector to query for the drag handle. (eg: '.custom-handle').
          // If handle element is found, that element will be used as drag handle.
          // If not, a default handle will be created
          dragHandleSelector: ".drag-handle", // default is undefined


          // Tags to be excluded for drag handle
          // If you want to hide the global drag handle for specific HTML tags, you can use this option.
          // For example, setting this option to ['p', 'hr'] will hide the global drag handle for <p> and <hr> tags.
          excludedTags: [], // default

          // Custom nodes to be included for drag handle
          // For example having a custom Alert component. Add data-type="alert" to the node component wrapper.
          // Then add it to this list as ['alert']
          //
          customNodes: [],
          callback:async (szAction:any,data:any)=>{
            if (szAction == 'saveDb'){
              await saveDataToDB();
            }else if (szAction == 'getData'){
              return {id:dataRef.current?.id,name:titleRef.current}
            }

          }
        }),
    )
  }

  const importConfig = global.g_edit_md_token;
  const editor = useEditor({
    autofocus: false,
    injectCSS: true,
    extensions: extensions,
    editorProps: {
      attributes: {
        // class: '',
      },
      handleDOMEvents:{
        keydown:(view,event)=>{

          if (event.key == '@'){
            if (!isInSingleFloatWindow()){
              window.showPopupCardList(editorRef.current);
            }
          }else if (event.key == KEYS.BACKSPACE){
            global.g_isRefreshLibraryInfoLink = true;
            window.closePopupCardList();

            //如果左侧highlight打开并且有选中sideBarRef在外面。。。。。
            // if (sideBarStatus.current == 2){
            //   if (sideBarRef.current?.onRemoveSelectedHighlight()){
            //     event.preventDefault();
            //   }
            // }
          }

          let bStop = true;
          if (event.ctrlKey || event.metaKey){
            if (event.key.toLowerCase() == KEYS.F){
              bStop = false;
            }else if (event.key.toLowerCase() == KEYS.S){
              bStop = false;
            }else if (event.key.toLowerCase() == KEYS.K){
              bStop = false;
            }
          }
          if (bStop){
            event.stopPropagation();
          }
        },
        // drop: () => true, // 阻止 drop
        // dragover: () => true,
      },
      handleDrop(editorView,event,slice,moved){
        if (event.dataTransfer?.files?.length > 0){
          // if (isImage(event.dataTransfer.files[0].path))return;//不处理拖动来的图片，别的地方处理了。
          //拖动进来的文件.
          const files = event.dataTransfer?.files;
          if (files[0].path.startsWith('http')){
            return;//链接图片，不用管........
          }

          let szImportMode = localStorage.getItem(KEY_FILE_IMPORT_MODE) || IMPORT_FILE_MODE_ASKME;
          if (isImage(files[0].path)){
            //图片直接复制一个。--不用管了。
            szImportMode = IMPORT_FILE_MODE_IMPORTMODE;
          }


          if (szImportMode == IMPORT_FILE_MODE_ASKME){
            window.showDialogFileImportDrag((szImportMode:any)=>{
              insertFileToLibrary(szImportMode,files[0]).then(res=>{
                const szDeeplink = createCopyLink("library", res.id,res.type,null,null,null,false);
                const selectNodeNP = editorRef.current?.$doc.querySelectorAll('paragraph', {id: event.srcElement.dataset.id})[0];
                let nPos = editorView.state.selection.to;
                if (selectNodeNP){
                  nPos = selectNodeNP.to;
                }
                setTimeout(async ()=>{
                  //如果是图片直接显示。
                  if (isImage(files[0].path)){
                    let szPath = files[0].path;
                    if (files[0].size > 20*1014*1024){
                      szPath = await ipcInvoke('resize-image-file',{filePath:files[0].path})
                    }
                    ipcInvoke('copy-file',{filePath:szPath}).then(imgId=>{
                      editor.chain().focus().setImage({ src:`atom://${imgId}`}).createParagraphNear().run()
                    })
                  }else{
                    insertDeeplinkToCard(szDeeplink,editorView,nPos);
                  }
                },10)
              })
            })
          }else{
            if (isImage(files[0].path)){
              //图片直接添加，不再插入到库....
              setTimeout(async ()=>{
                if (isImage(files[0].path)){
                  let szPath = files[0].path;
                  if (files[0].size > 20*1014*1024){
                    szPath = await ipcInvoke('resize-image-file',{filePath:files[0].path,name:files[0].name})
                  }
                  ipcInvoke('copy-file',{filePath:szPath}).then(imgId=>{
                    editor.chain().focus().setImage({ src:`atom://${imgId}`}).createParagraphNear().run()
                  })
                }else{
                  insertDeeplinkToCard(szDeeplink,editorView,nPos);
                }
              },10)
            }else{
              insertFileToLibrary(szImportMode,event?.dataTransfer?.files[0]).then(res=>{
                const szDeeplink = createCopyLink("library", res.id,res.type,null,null,null,false);
                const selectNodeNP = editorRef.current?.$doc.querySelectorAll('paragraph', {id: event.srcElement.dataset.id})[0];
                let nPos = editorView.state.selection.to;
                if (selectNodeNP){
                  nPos = selectNodeNP.to;
                }
                setTimeout(async ()=>{
                  if (isImage(files[0].path)){
                    let szPath = files[0].path;
                    if (files[0].size > 20*1014*1024){
                      szPath = await ipcInvoke('resize-image-file',{filePath:files[0].path,name:files[0].name})
                    }
                    ipcInvoke('copy-file',{filePath:szPath}).then(imgId=>{
                      editor.chain().focus().setImage({ src:`atom://${imgId}`}).createParagraphNear().run()
                    })
                  }else{
                    insertDeeplinkToCard(szDeeplink,editorView,nPos);
                  }
                },10)
              })
            }

          }
          event.preventDefault();
          event.stopPropagation();
        }
        global.g_isDragInCard = true;
        setTimeout(()=>{
          //避免未释放的时候 global.g_currentDragLibraryItem 还未设置值
          if (global.g_currentDragLibraryItem){
            //这里插入拖动进来的。。。。
            const selectNodeNP = editorRef.current?.$doc.querySelectorAll('paragraph', {id: event.srcElement.dataset.id})[0];
            let nPos = editorView.state.selection.to;
            if (selectNodeNP){
              nPos = selectNodeNP.to;
            }

            let szDeeplink:any;
            if (global.g_currentDragLibraryItem.type == 'videoAnno' || global.g_currentDragLibraryItem.type == 'audioAnno'){
              szDeeplink = createCopyLink('highlight',global.g_currentDragLibraryItem.libraryId,'videoNote',global.g_currentDragLibraryItem.id,null,null,false);
            }else{
              szDeeplink = createCopyLink("library", global.g_currentDragLibraryItem.id,global.g_currentDragLibraryItem.type,null,null,null,false);
            }
            const libraryItem = {...global.g_currentDragLibraryItem};
            setTimeout(async ()=>{
              if (libraryItem.type == 'image'){
                //图片类型的直接以图片方式插入。
                const id = libraryItem.id;
                let szFileName = localStorage.getItem(KEY_FILE_DIR) + libraryItem.fileName;
                if (libraryItem.isAbsolutePath){
                  szFileName = libraryItem.fileName;
                }
                const szExt = getFileNameExt(libraryItem.fileName);
                const imgId = await ipcInvoke('copy-file',{filePath:szFileName})
                editorRef.current?.chain().focus().setImage({src: 'atom://' + imgId}).run()
              }else{
                insertDeeplinkToCard(szDeeplink,editorView,nPos);
              }

            },10)

            global.g_currentDragLibraryItem = null;
          }
          global.g_isDragInCard = false;
        },100)
      },
      handlePaste(view, event, slice) {
        if (editorRef.current){
          return handlePaste(editorRef.current,view,event,slice);
        }
      },
      clipboardTextParser(text, context, plain, view) {
        if (editorRef.current) {
          return handleClipboard(editorRef.current,text);
        }
      },
      transformPastedText(text, plain, editorView) {
        return handleTransformPastedText(text, plain, editorView);
      },
      transformPastedHTML(html,view) {
        if (event?.clipboardData?.files?.length > 0){
          //有文件的时候，不处理html.....
          return '';
        }
        return handleTransformPastedHTML(html, view);
      },
      handleClick(e, r, k) {
        if (k.button == 2)return;//右键不要处理..
        //这个为什么要设置？导致反复的选择首次不能选中....
        const {from, to} = e.state.selection
        if (to > from) {
          setPos([true, r])
          //取消选中
          editorRef.current.chain().focus().setTextSelection(r).run();
        } else {
          setPos([false, 0])
        }
        //这个为什么要设置？导致反复的选择首次不能选中....end-

        //@ts-ignore
        // window.closeImgAction();
        postMessage(EVENT_CLOSE_IMAGE_ACTION);

        window.closePopupCardList();
      },
    },
    onUpdate(editor0) {

      let tempArr = []
      let reverseInlineLatexArr = []
      editor.state.doc.descendants((node, pos) => {
        if (node.type.name === "paragraph" && node.content) {
          const content = node.content.content; // ProseMirror Node 的子节点数组在 content.content 里

          for (let i = 0; i < content.length - 1; i++) {
            const current = content[i];
            const next = content[i + 1];
            if (
                current.type.name === "latexInline" && current.attrs?.dollarBoundaries===1 &&
                next.type.name === "text" &&
                /^\d/.test(next.text || "")) {
              tempArr.push(current)
            }
          }
        } else if (node.type.name === "latexInline" && tempArr?.[0]?.attrs?.id === node.attrs.id) {
          reverseInlineLatexArr.push({
            node: node,
            pos: pos
          })
          tempArr.shift()
        }
      });
      if (reverseInlineLatexArr.length > 0) {
        for (let i = 0; i < reverseInlineLatexArr.length; i++) {
          const element = reverseInlineLatexArr[i];
          const textNode = editor.state.schema.text(`$${element.node.attrs.metaData}$`);

          // 用 replaceWith 把原来的节点替换掉
          const tr = editor.state.tr.replaceWith(element.pos, element.pos + element.node.nodeSize, textNode);
          editor.view.dispatch(tr);
        }
      }


      if (!editorRef.current){
        editorRef.current = editor0.editor;
      }
      if (!editor0.editor.isEditable)return;
      if (isEdited === 1) {
        isEdited = 2
      }

      if (editor0.isCardDeleteImage){
        editor0.isCardDeleteImage = false;
        return;
      }

      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        let html = editor?.getHTML()
        /** 最后为图片时， 作为p标签 */
        if (/\<img[^\>]+\>$/.test(html)) {
          editor?.commands.setContent(html + '<p></p>')
        }
        //最是deeplink,插入p
        // editor.commands.setContent(html + '<p></p>')
        if (isCardEmpty(html)){
          //清空...
          if (props.onEmptyData){
            props.onEmptyData(getSaveData());
          }
        }
      }, 200)

      //别的地方也更新..--控制刚打开edit时的保存........
      //控制一下，1s更新一次....
      if (!isCardEmpty(editor0.editor.getHTML()) && !mIsFristSetData) {
        syncUpdate();
      }

      mIsFristSetData = false;
    },
    onSelectionUpdate() {
      const { from, to } = editor.state.selection;
      const selectNode = []
      editor.state.doc.nodesBetween(from, to, (node, pos) => {
        // console.log('---node--', node);
        selectNode.push({
          nodeType: node.type.name,
        })
      });
      // console.log('selectNode', selectNode);
      if (selectNode.length > 1 || (selectNode.length === 1 && selectNode[0].nodeType !== 'image')) {
        setIsShowTextBar(true);
      } else if (selectNode.length === 1 && selectNode[0].nodeType === 'image') {
        setIsShowTextBar(false);
      }

      // const resolvedPos = editor.state.doc.resolve(from);
      // // 获取当前节点
      // const currentNode = resolvedPos.node();
      // console.log('---currentNode',currentNode,from, to );
      // selectHighlightId(editor);
    },
    onCreate(editor0) {
      editorRef.current = editor0.editor;
      editorRef.current.isShowSliderTip = true;//改为所有的地方都要吧，(props.from == FROM_PAGE_CARD || props.from == FROM_JOURNAL || (props.subFrom && props.subFrom != FROM_LIBRARY));
      if (props.onInitComplete){
        props.onInitComplete(editorRef.current);
      }

    },
    parseOptions: {
      preserveWhitespace: 'full',
    },
    onBlur(editor0){
      if (props.onSaveData){
        props.onSaveData(getSaveData())
      }

    },
    onFocus(editor0){

    },
  });
  // window.ed = editor;

  useEffect(()=>{
    mHasTitleEmpty.current = hasTitleEmpty;
  },[hasTitleEmpty])


  useEffect(() => {
    isEdited = 0
    if (editor && props.data) {

      mIsFristSetData = true;
      setTimeout(()=>{
        editor.commands.setContent(replaceLatexInParagraph(migrateInlineCodeToOfficial(props.data.doc)));
        editor.cardId = props.data.id;
      },10);

      setTitle(props.data.name === t('Untitled') ? '' : props.data.name);

      setTimeout(() => {
        document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`).style.height = document.querySelector('#NOTE_TITLE_INPUT2').offsetHeight + 'px'
      }, 0)

      if (global.g_isPresentMode) {
        if (props.data.name) {
          setHasTitleEmpty(props.data.name == '' || props.data?.name.toLowerCase() == t("Untitled").toLowerCase())
        } else {
          setHasTitleEmpty(true);
        }
      } else {
        if (props.data.hasTitle != undefined){
          setHasTitleEmpty(!props.data.hasTitle);
        }else{
          if (!isInSingleFloatWindow()){
            setHasTitleEmpty(false);
          }
        }
      }

      if (APP_WEB) {
        editor.setEditable(false);
      }
    }
    isEdited = 1
    editor?.setEditable(!global.g_isPresentMode);

    let div = null;
    if (props.from == FROM_LIBRARY) {
      div = document.getElementById('div-edit-container');
    } else {
      div = document.getElementById('divNoteContainer');
    }
    if (div) {
      setModalHeight(div.clientHeight);
    } else {
      setModalHeight(document.body.clientHeight);
    }

    setTimeout(() => {
      if (txtTitleRef.current) {
        txtTitleRef.current.style.height = divTitleRef.current?.offsetHeight + 'px';//为什么在journal 侧栏中这个值会变成342？？？？？？？？
        if (isInPageCard()){
          refreshTitleHeight();
        }
        if (props.from == FROM_HISTORY){
          editor?.setEditable(false);
          // textArea.setAttribute('readonly','');
          txtTitleRef.current.readOnly = true;
          // editorRef.current.view.dom.contentEditable = 'false';
          editorRef.current.view.dom.style.userSelect = 'text!important';
        }else if (props.from == FROM_JOURNAL){
          txtTitleRef.current.style.height = 40 + 'px';
        }
      }
      // console.log('textArea.style.height '+textArea.style.height );
    }, 10)

    //默认info一次计算.
    // libraryInfoRef?.current?.onShowDialog('library', {...props.data}, false);

    // setTimeout(()=>{
    //   window.hookATags();
    // },500)

    dataRef.current = props.data;

    const dialogDiv = document.querySelector('#card-dialog-'+props.data?.id);
    if (dialogDiv){
      dialogResizeObserver.observe(dialogDiv);
    }

    if (props.data){
      window.refreshList['updateAnnoComment_'+props.data.id] = async (highlight:any)=>{
        const highlights = await getAllHighlightContent(editor);
        const item = highlights.content.find(p=>p.id == highlight.id);
        if (item){
          item.node.attrs.noteText = highlight.comment;
        }
        //还要刷新当前已经打开的highlightbar里面的 -----
        window.globalRefreshList('refresh_highlightbar_');
      }

      window.refreshList['refreshSelfCard_'+uuid.current] = globalRefreshData;

      /**
       * 移除这个卡片的注记，需要的地方多了。好几个地方同时打开。。。。
       */
      window[`removeCardHighlight_${props.data.id}`] = (highlight:any)=>{
        if (highlight.annoType == 'image'){
          const selectedNP = editor?.$doc.querySelectorAll('image', {id: highlight.id})[0]
          if (selectedNP){
            selectedNP.node.attrs.highlightImgUrl = ""
            // document.dispatchEvent(new CustomEvent('changeHighlight'));
            // document.dispatchEvent(new CustomEvent('refreshSidebar'));
          }
        }else{
          editor?.chain()
              .focus()
              .setTextSelection({from: highlight.pos, to: highlight.end})  // 设置文本选择范围
              .unsetHighlight()
              .run();
        }
      }
    }

    //尝试刷新扩展
    if (editor){
      window.refreshBlockMenuExtends = ()=>{
        const blockMenu = editor.extensionManager.extensions.find(ext => ext.name === 'blockMenu')
        //
        // if (nIndex != -1) {
        //   // 1. 移除扩展
        //   editor.extensionManager.extensions.splice(nIndex,1);
        //
        //   // 2. 添加新的扩展实例
        //   editor.extensionManager.extensions.push(
        //      getBlockMenu()
        //   )
        //
        //   editor.view.updateState(editor.state);
        // }
        if (blockMenu){
          blockMenu.options.items = defaultBlockMenuItems();
          if (window.refreshBlockMenu){
            window.refreshBlockMenu();
          }
        }
      }
    }


    const handleBlockLinkClick = (event) => {
      if (props?.data?.id === event?.detail?.noteId && props?.data?.id !== undefined) {
        // 直接跳转
        const selectedNP = editor.$doc.querySelectorAll(event.detail.blockType, { id: event.detail.blockId })[0]
        // editor.chain().blur().setNodeSelection(selectedNP.pos - 1).scrollIntoView().run();
        const coords = editor.view.coordsAtPos(selectedNP.pos - 1);
        const scrollContainer =
            editor.view.dom.parentElement.parentElement.parentElement;
        const clientHeight = document.documentElement.clientHeight;
        scrollContainer.scrollTo({
          top: scrollContainer.scrollTop + coords.top - clientHeight / 2,
          behavior: "smooth",
        });

        editor.chain().blur().setNodeSelection(selectedNP.pos - 1).run();
      } else {
        // 关闭当前弹窗后跳转
        document.dispatchEvent(new CustomEvent('outsideBlockLinkClick', {
          detail: {
            noteId: event.detail.noteId,
            blockId: event.detail.blockId,
            blockType: event.detail.blockType,
            nagivateEvent:event.detail.nagivateEvent
          }
        }))
      }
    }
    document.addEventListener('blockLinkClick', handleBlockLinkClick);


    return ()=>{
      if(dialogDiv){
        dialogResizeObserver.unobserve(dialogDiv);
      }
      if (props.data){
        delete window.refreshList['updateAnnoComment_'+props.data?.id];
        delete window.refreshList['refreshSelfCard_'+uuid.current];
        delete window[`removeCardHighlight_${props.data.id}`];
        //刷新有关该card的所有注记..
        window.globalRefreshList('refreshLibraryCardAnnoList_',props.data.id);
      }
      if (editor){
        delete  window.refreshBlockMenuExtends;
      }
      document.removeEventListener('blockLinkClick', handleBlockLinkClick);
    }

  }, [editor, props.data]);

  // 监听编辑器选中变化，更新字体大小显示
  useEffect(() => {
    if (!editor) return;

    const updateFontSize = () => {
      const fontSize = editor.getAttributes('textStyle').fontSize?.replace('px', '') || DEFAULT_TIPTAP_FONT_SIZE;
      setCurrentFontSize(fontSize);
    };

    // 监听选中变化
    editor.on('selectionUpdate', updateFontSize);
    // 监听内容变化
    editor.on('update', updateFontSize);

    return () => {
      editor.off('selectionUpdate', updateFontSize);
      editor.off('update', updateFontSize);
    };
  }, [editor]);

  useEffect(()=>{
    titleRef.current = title;
  },[title])

  // 检查选区是否应用了 highlight mark
  function selectHighlightId(editor) {
    // 获取当前编辑器实例的 selection
    const { selection } = editor.state;
    const { from, to, empty } = selection;

    // 如果选区为空（光标状态），检查光标位置是否有 highlight
    if (empty) {
      const $pos = selection.$from;
      const highlightMarkType = editor.schema.marks.highlight; // 假设 highlight 是 mark 的名称
      const has = !!highlightMarkType.isInSet($pos.marks());
      if (has){
        const szId = highlightMarkType.attrs?.id;
        console.log(szId);
        return szId;
      }
    }

    // 如果选区非空，检查选区范围内是否有 highlight
    let hasHighlightId = '';
    editor.state.doc.nodesBetween(from, to, (node) => {
      const mark = node.marks.find((mark) => mark.type.name === 'highlight')
      if (mark) {
        hasHighlightId =  mark.attrs?.id;
        return false; // 提前终止遍历
      }
      return true;
    });
    return hasHighlightId;
  }


  /**
   * 全局的刷新----
   */
  function globalRefreshData(data,extra){
    if (!data)return;
    if (extra?.selfUUID == uuid.current)return;//自己不更新自己....
    if (data.id == props.data.id){
      props.data.name = data.name;
      setTitle(data.name);
      if (data.doc){
        let szDoc = data.doc;
        props.data.html = szDoc;
        editorRef.current.commands.setContent(szDoc);
      }
    }
  }

  function onResize(){
    if (props.from == FROM_JOURNAL){
      // setMarginJournal(`-${(document.body.clientWidth-LEFT_MENU_WIDTH)*0.16}px`)
      // setPaddingJournal(`${(document.body.clientWidth-LEFT_MENU_WIDTH)*0.16}px`)
      setMarginJournal('0px');
    }else{
      setMarginJournal('0px');
      setPaddingJournal('0px')
    }
  }

  /**
   * 监听dialog的resize事件
   */
  const dialogResizeObserver = new ResizeObserver((entries, observer) => {
    // console.log('dialogResizeObserver',entries,observer);
    refreshTitleHeight();
  });

  useEffect(()=>{
    window.addEventListener('resize',onResize);
    return ()=>{
      window.removeEventListener('resize',onResize)
    }
  })

  useEffect(()=>{
    onResize();

    return ()=>{
      delete window.cardUpdateCallbacks[uuid.current];
    }
  },[])


  useLayoutEffect(()=>{
    return ()=>{
      if (!dataRef.current?.id)return;
      saveDataToDB().then(res=>{
        ////这里，要遍历标注，重新保存更改的...
        const highlights = getAllHighlightContent(editorRef.current);
        batchCardHighlight(highlights.content,dataRef.current?.id,titleRef.current).then(res=>{
          if (isInPageLibrary() || props.from == FROM_LIBRARY){
            //这里只需要刷新HOME的。。。
            window.globalRefreshList('refresh_single_library_item_',dataRef.current.id,{onlyHomeLibrary:true});
            // window.globalRefreshList('refreshLibraryList_')
          }else if (isInPageTask()){
            window.globalRefreshList('refresh_tasks_');
          }else if (isInPageTag()){
            window.globalRefreshList('refresh_tableview_single_data_',dataRef.current.id);
            window.globalRefreshList('refresh_tag_item_list_',dataRef.current);
          }else if (isInJournal()){
            if (window.refreshMonthly){
              window.refreshMonthly();
            }
          }
          else{
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
          }
        });
      });//保存下数据.
    }
  },[])

  /**
   * 刷新标题高度
   */
  const refreshTitleHeight = ()=>{
    setTimeout(()=>{
      if (txtTitleRef.current){
        txtTitleRef.current.style.height = '0px';
        txtTitleRef.current.style.height = txtTitleRef.current.scrollHeight + 'px';
      }
    },100)
  }

  /**
   * 获取焦点
   */
  const onEditorFocus = ()=>{
    editorRef.current?.commands?.focus();
  }

  //全部用的这种全局的，怎么搞。只能也跟着搞全局的方法。。。。。
  window.getCardTitle = ()=>{
    return title;
  }

  window.showNoteLink = () => {
    setIsShowLink(true);

    const selection = window.getSelection();
    if (selection?.rangeCount) {
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      // 返回光标相对于编辑器容器的位置
      setLinkPosition({
        left: rect.left + 'px',
        top: rect.top + 'px'
      })
    }
  }

  window.GEditor = editor
  // editor.commands.blur
  useEffect(() => {
    /** 获取笔记图片 */

    window.GGetEditorChanged = () => isEdited === 2;

    setTimeout(() => {
      if (isInSingleFloatWindow()){
        editorRef.current.commands.focus();
      }else{
        txtTitleRef.current?.focus();
      }
    }, 100)

    let bgTask = setInterval(() => {
      setBackground(editorRef.current?.getAttributes?.("textStyle")?.backgroundColor || '#dae9f8')
    }, 300)

    if (global.g_isPresentMode) {
      document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`)?.setAttribute('readonly', 'true');
    } else {
      document.querySelector(`#NOTE_TITLE_INPUT-${props.data?.id}`)?.removeAttribute('readonly');
    }

    setTimeout(()=>{
      document.querySelectorAll('.ProseMirror')?.forEach(p=>p.addEventListener('mousemove',handlerShow));

      let editableDiv = document.querySelector('#NODE_EDITOR_EL');
      if (props.from == FROM_JOURNAL){
        // editableDiv = document.querySelector('.tiptap.ProseMirror');
      }
      const handleClick=(event) => {
        const {from,to} = editorRef.current.state.selection;
        if (from != to) {
          return;
        };
        if (event.target == editableDiv) {
          editorRef.current?.commands.insertContentAt(editorRef.current?.state.doc.content.size, '<p></p>', {
            updateSelection: true
          })
          editorRef.current.commands.focus();
        }
      }

      if (editableDiv){
        editableDiv.removeEventListener('click',handleClick);
        editableDiv.addEventListener('click', handleClick);
      }

    },500)



    return () => {
      delete window.GEditor
      document.querySelectorAll('.ProseMirror')?.forEach(p=>p.removeEventListener('mousemove',handlerShow));
      delete window.GGetEditorChanged
      delete window.GEditorupdateBackground;

      clearInterval(bgTask)
    }
  }, [])

  useEffect(() => {
    if (props.data){
      //这里只有右侧栏、底部栏更新infoNotes的时候使用。--还要考虑多浮窗卡片的情况...
      window.refreshList['updateInfoNotes_'+props.data.id] = (data:any)=>{
        if (!data)return;
        if (data.id == props.data.id){
          props.data.infoNotes = data.infoNotes;
          props.data.infoUrl = data.infoUrl;
        }
      }
    }

    return ()=>{
      if (props.data){
        delete window.refreshList['updateInfoNotes_'+props.data.id]
      }
    }
  }, [props.data]);

  useLayoutEffect(() => {

    window.getEditorCanvas = async (limit = true, isShare = false) => {
      const el = document.getElementById(
          `NODE_EDITOR_EL`
      ) as HTMLDivElement;
      const w = el.clientWidth;
      let param: any = {
        scale: 4,
        logging: false,
        useCORS: true,
        x: 0,
        y: 0,
        width: w,
        // height: w * 1.3,
        backgroundColor: "#ffffff",
      }
      if (limit) {
        param.height = w * 1.3
      }
      if (isShare) {
        setDraw(true)
        await new Promise((resolve) => setTimeout(resolve, 200));
        return await html2canvas(el, param).finally(() => {
          setDraw(false)
        })
      }
    }

    return () => {
      delete window.getEditorCanvas
    }
  });

  //同步消息
  useEffect(() => {
    recvMessage(EVENT_SYNC_NOTE_DATA, (msg, data) => {
      if (props.data.id == data.data.id) {//同一个ID才处理....
        props.data.id = data.data.id;
        props.data.name = data.data.name;
        props.data.doc = data.data.doc;
        setTitle(data.data.name);
        editor?.commands.setContent(data.data.doc);

        //刷新info--不能实时刷新会卡。。。。。。。。。
        libraryInfoRef?.current?.onShowDialog('library', {...props.data,doc:props.data.doc}, true);
      }
    })

    /**
     * 当前在pagecard页面，弹出的card 中关闭了弹窗.
     */
    recvMessage(EVENT_REFRESH_INFO,(msg,data)=>{
      if (props.from == FROM_PAGE_CARD){
        if (props.data){
          libraryInfoRef?.current?.onShowDialog('library', {...props.data,doc:props.data.doc}, false);
        }
      }
    })

    /**
     * 保存card
     */
    recvMessage(EVENT_SAVE_CARD,(msg,data)=>{
      if (data.data.id == props.data?.id){
        syncUpdate();
      }
    })

    /**
     * 更新card中的注记备注
     */
    recvMessage(EVENT_UPDATE_HIGHLIGHT_ANNO,async (msg,data)=>{
      const highlights = await getAllHighlightContent(editorRef.current);
      const item = highlights.content.find(p=>p.id == data.data.id);
      if (item){
        item.node.attrs.noteText = data.data.comment;
        //保存card...
        saveDataToDB();
        //刷新
        // sideBarRef.current?.onRefreshHighlight();
        if (window.onRefreshHighlight){
          window.onRefreshHighlight();
        }
      }
    })

    /**
     * 更新标签
     */
    recvMessage(EVENT_UPDATE_TAG,(msg,data)=>{
      if (data.data.id == props.data?.id){
        dataRef.current.tags = data.data.tags;
      }
    })


    return () => {
      unSubscribe(EVENT_SYNC_NOTE_DATA);
      unSubscribe(EVENT_REFRESH_INFO);
      unSubscribe(EVENT_SAVE_CARD);
      unSubscribe(EVENT_UPDATE_HIGHLIGHT_ANNO);
      unSubscribe(EVENT_UPDATE_TAG);
    }
  })


  const handlerShow = (event) =>{
    const divCustomDrag = document.querySelector(".drag-handle");

    if(divCustomDrag){
      let nMarginTop = '0px'
      if (selectedDragNode){
        if (selectedDragNode.attrs.level == 1){
          nMarginTop = '6px'
        }else if (selectedDragNode.attrs.level == 2){
          nMarginTop = '3px'
        }else if (selectedDragNode.attrs.level == 3){
          nMarginTop = '2px'
        }
      }
      divCustomDrag.style.marginTop = nMarginTop;
      if (Global.g_isPresentMode){
        divCustomDrag.style.display = "none";
      }else{
        divCustomDrag.style.display = "flex";
      }

    }
  }

  const handlerHidden = (event) =>{
    const divCustomDrag = document.querySelector(".drag-handle");
    if(divCustomDrag){
      divCustomDrag.style.display = "none";
    }
  }

  const syncUpdate = async () => {
    if (!props.data)return;

    const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
    const name = props.data?.name;
    let createTime = props.data.createTime;
    let updateTime = Date.now();
    if (!createTime) {
      createTime = updateTime;
    }
    const data = {
      ...(props.data || {}),
      doc: html,
      type: props.data?.type || 'card',
      name: name || '',
      createTime,
      updateTime
    };
    if (props.from == FROM_PAGE_CARD){
      data.viewTime = Date.now();
      dataRef.current = {...data};
    }

    //刷新info--不能实时刷新会卡。。。。。。。。。
    // let isSimpleRefresh = (Date.now() - mInitTime.current) > 1000;
    libraryInfoRef?.current?.onShowDialog('library', {...data}, mIsSimpleRefresh.current);
    mIsSimpleRefresh.current = true;
    global.g_isRefreshLibraryInfoLink = false;

    //刷新别的界面的相同的ID。。。。
    window.globalRefreshList('refreshSelfCard_',data,{selfUUID:uuid.current});

    //保存到数据库
    if (data.id){
      const res = await updateCard({...data});
      if (props.from != FROM_JOURNAL && props.from != FROM_HISTORY){
        // postMessage(EVENT_UPDATE_NOTE, {data: data, isInsertCanvas: false, isAutoSave: true,source:props.source,from:props.from,isSaveDb:false});
      }

      postMessage(EVENT_REFRESH_DEEPLINK_TITLE,{data:res});
      const newData = {...data};
      if (!newData.doc && newData.html){
        newData.doc = newData.html;
        delete newData.html;
      }
      // postMessage(EVENT_SYNC_REFRESH_DRAW_CARDEDIT,{...newData});
      window.globalRefreshList('update_sync_refresh_draw_cardedit_',{...newData})

      //额外的同步操作。。。。
      postMessage(EVENT_REFRESH_EDIT_CARD_NEW,{card:{...newData},from:props.from,subFrom:props.subFrom});

      //调用全局的所有更新...
      const arrayKeys = Object.keys(window.cardUpdateCallbacks);
      for (let i=0;i<arrayKeys.length;i++){
        if (arrayKeys[i] == uuid.current)continue;
        const callback = window.cardUpdateCallbacks[arrayKeys[i]];
        if (callback){
          callback({...newData});
        }
      }
    }

    if (props.onUpdate){
      props.onUpdate(data);
    }

    if (window.refreshInfo){
      window.refreshInfo(data);
    }

  }

  /**
   * 保存到数据库
   */
  const saveDataToDB = async ()=>{
    if (props.from == FROM_HISTORY)return;

    //!!!!!这个东西，到处的变量不在一个实例里面。。。
    const html = imgServer.parserImgFromHtml(editorRef.current?.getHTML() as string);
    if (isCardEmpty(html) && !txtTitleRef.current.value){
      const dbCard = await getCardById(dataRef.current?.id);
      if (!dbCard){
        //是新建的，又是空白的。。-不保存
        return;
      }
    }

    if (dataRef.current?.id){
      if (global.g_deletedCardIds[dataRef.current?.id]){
        dataRef.current.isDeleted = 1;
        global.g_deletedCardIds[dataRef.current?.id] = false;
      }
    }

    const name = dataRef.current?.name || txtTitleRef.current?.value || '';
    let createTime = dataRef.current?.createTime;
    let updateTime = Date.now();
    if (!createTime) {
      createTime = updateTime;
    }
    const data = {
      ...(dataRef.current || {}),
      doc: html,
      type: dataRef.current?.type || 'card',
      name: name || '',
      createTime,
      updateTime
    };

    if (data.id){
      updateCard(data).then(res=>{
        //如果有右侧栏打开的project,还要更新右侧栏打开的project的 画布上的这个card....
        let iframe = document.getElementById('iframe-slider-drawindex-container');
        if (iframe){
          iframe.contentWindow.postMessage({action:'refresh-canvas-card',data:data})
        }
        //全局侧栏的
        iframe = document.getElementById('iframe-slider-global-drawindex-container');
        if (iframe){
          iframe.contentWindow.postMessage({action:'refresh-canvas-card',data:data})
        }
      });
    }
  }

  useImperativeHandle(ref, () => {
    const expose: TEditorRef = {
      save() {
        if (!props.data)return;

        //保存光标位置
        // const pos = editor?.state.selection.from;
        // localStorage.setItem(KEY_CARD_CURSOR_POS_ + props.data.id, pos + '');

        let arrayDivs = document.getElementsByClassName('tiptap ProseMirror');
        let thumbHtml = '';
        if (arrayDivs && arrayDivs.length > 0) {
          const editDiv = arrayDivs[0].childNodes;
          for (let i = 0; i < editDiv.length; i++) {
            thumbHtml += editDiv[i].outerHTML;
            const szContent = removeHtmlTags(thumbHtml);
            if (szContent.length > 100) {
              break;
            }
          }
        }
        return new Promise((res) => {
          const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);

          const name = txtTitleRef.current?.value;//getNoteName()
          if ((!html.length) && name === t('Untitled')) return noteServer.openTip("error", "空白内容无法保存");
          window.getEditorCanvas().then(function (c) {
            res({
              ...(props.data || {}),
              // img: c.toDataURL("image/jpeg"),
              doc: html,
              thumbHtml: thumbHtml,
              name: name || ''
            });
          });
          isEdited = 1
        });
      },
      rename() {
        txtTitleRef.current?.focus();
      },
      onForceUpdate() {
        forceUpdate()
      },
      getSaveData:getSaveData,
      onExportPdf:onExportPdf,
      onExportMarkdown:onExportMarkdown,
      onUpdateSidebarStatus:onUpdateSidebarStatus,
      refreshTitleHeight:refreshTitleHeight,
      onEditorFocus:onEditorFocus
    };
    return expose;
  });

  function onExportPdf(){
    const name = txtTitleRef.current?.value || '';
    const data = getSaveData()

    //保存到doc
    editDoc((data.id || LASTEST_NOTE_DOC),data.doc,data.name).then(res=>{
      setTimeout(() => {
        ipcSend('save-pdf-to-system', (data.id || LASTEST_NOTE_DOC), name)
      }, 10);
    })
  }

  /**
   * markdown
   */
  async function onExportMarkdown(){
    window.showProgress(t("Exporting"))

    const name = txtTitleRef.current?.value || '';

    editor?.chain().export({
      format: 'md',
      onExport(context) {
        const { blob, error } = context
        if(error){
          noteServer.openTip("error", t("ExportMarkdownFail"));
          return;
        }
        blob.arrayBuffer().then(arrayBuffer => {
          window.closeProgress();

          ipcSend('save-markdown-to-system', arrayBuffer, name)
        });
        // context.download()  该API存在不能自定义 导出文件名的缺陷
      },
    })
  }

  /**
   * 更新左侧目录是否打开
   * @param nSidebarStatus
   */
  function onUpdateSidebarStatus(nSidebarStatus){
    sideBarStatus.current = nSidebarStatus;
  }

  /**
   * 获取要保存的数据....
   */
  function getSaveData(){
    //保存光标位置
    // const pos = editor?.state.selection.from;
    // localStorage.setItem(KEY_CARD_CURSOR_POS_ + props.data?.id, pos + '');

    let arrayDivs = document.getElementsByClassName('tiptap ProseMirror');
    let thumbHtml = '';
    if (arrayDivs && arrayDivs.length > 0) {
      const editDiv = arrayDivs[0].childNodes;
      for (let i = 0; i < editDiv.length; i++) {
        thumbHtml += editDiv[i].outerHTML;
        const szContent = removeHtmlTags(thumbHtml);
        if (szContent.length > 100) {
          break;
        }
      }
    }
    const html = imgServer.parserImgFromHtml(editor?.getHTML() as string);
    if (!html)return;

    let name = title;
    if (txtTitleRef.current){
      name = txtTitleRef.current?.value || '';
    }else{
      console.log('be be release!')
    }
    if ((!html.length) && name === t('Untitled')) return noteServer.openTip("error", "空白内容无法保存");
    if (!props.data){
      return{
        doc:html,
        thumbHtml:thumbHtml,
        name:name || ''
      }
    }
    props.data.doc = html;
    props.data.thumbHtml = thumbHtml;
    props.data.name = name || '';
    return props.data;
  }

  function onClick(e) {

    /** 点击编辑器本身 */
    let clickInside = e.target?.classList?.value.includes?.('ProseMirror')

    setTimeout(() => {
      //这个是干什么？？？第二次选择的时候就清空了选择无法选中了。
      // const selection2 = window.getSelection()
      // if (selection2.type === 'Range' && pos[0]) {
      //   editor.commands.focus(pos[1])
      //   setPos([false, 0])
      // }

      if (clickInside) {
        let html = editor.getHTML()
        /** 最后为图片时， 作为p标签 */
        if (!/\<\/p\>$/.test(html)) {
          editor.commands.setContent(html + '<p></p>')
        }
      }

      if (editorContentRef.current && editorContentRef.current.contains(e.target) && editor.isActive('highlight') && (e.metaKey || e.ctrlKey)) {
        // 获取focus区域附近的highlight
        const { state, view } = editor;
        const { selection } = state;
        const { from, to } = selection;
        const resolvedPos = editor.state.doc.resolve(from);
        // 获取当前节点
        const currentNode = resolvedPos.node();
        const currentMarks = resolvedPos.marks();
        const currentHighlightMark = currentMarks.find(mark => mark.type.name === 'highlight')
        document.dispatchEvent(new CustomEvent('highlightBar-expand', {
          detail: {
            id: currentHighlightMark?.attrs.id
          },
        }))
      }

    }, 10)
  }

  async function rightClick(e) {
    // e.stopPropagation()
    e.preventDefault()

    // ipcInvoke('show-context-menu-common')
    // return

    console.log('---LOG');
    const editorDom = document.querySelector<HTMLDivElement>('.ProseMirror')

    const selection = document.getSelection()!

    let range: Range | null = null;

    const enabled = !(selection.isCollapsed && editorDom?.contains(selection.anchorNode)!)

    if (enabled) {
      range = selection.getRangeAt(0).cloneRange()
    }
    const menus = [
      {
        label: t('Copy'),
        key: 'copy',
        enabled
      },
      {
        label: t('Cut'),
        key: 'cut',
        enabled
      },
      {
        label: t('Paste'),
        key: 'paste'
      },
      {
        label: t('Select all'),
        key: 'Select all'
      },
      {
        label: t('Word static'),
        key: 'word_count'
      },
    ]
    const key = await RightMenu.open(e.pageX, e.pageY, menus)
    if (key === "copy") {
      selection.removeAllRanges();
      selection.addRange(range!);
      document.execCommand('copy');
    }
    if (key === 'cut') {
      selection.removeAllRanges();
      selection.addRange(range!);
      document.execCommand('cut');
    }
    if (key === "paste") {
      editor.commands.focus()
      setTimeout(() => {
        document.execCommand('paste');
      }, 0)
    }
    if (key === 'Select all') {
      document.execCommand('SelectAll');
    }
    if (key === 'word_count') {
      window.GOpenCountWords?.()
    }
  }

  const isTitleEmpty = () => {
    if (global.g_isPresentMode) {
      return !title || (title.toLowerCase() == t('Untitled').toLowerCase())
    }
    return false;
  }

  const getEditorLRPadding = () => {
    const nW = document.body.clientWidth;
    return nW / 10 + 'px';
  }

  const getPadding = () => {
    if (props.from == FROM_LIBRARY) {
      return '26px';
    }
    return fullScreen ? '286px' : getEditorLRPadding();
  }

  const getPaddingTop = ()=>{
    if (props.from == FROM_JOURNAL){
      return '12px';
    }else if (props.from == FROM_PAGE_CARD){
      return '16px';
    }else if (props.from == FROM_LIBRARY || props.source == 'rightSlider'){
      return '36px';
    }
    if (hasTitleEmpty){
      return '12px';
    }
    if (APP_WEB){
      return '36px';
    }
    return '66px';
  }

  const getHeight = ()=>{
    if (!isInfoVisible()){
      return '100%'
    }

    if (props.from == FROM_JOURNAL){
      if (props.subFrom == FROM_LIBRARY){
        return 'auto';
      }
      return '100%'
    }else if (props.from == FROM_PAGE_CARD){
      return 'auto';
    }

    return 'auto';
  }

  /**
   * 底下的info 是否可见
   */
  const isInfoVisible = ()=>{
    return !global.g_isPresentMode && props.from != FROM_PDF &&  props.from != FROM_JOURNAL && props.from != FROM_HISTORY && localStorage.getItem(KEY_GLOBAL_INFO_VISIBLE) !== 'invisible';
  }

  /**
   * 显示链接
   */
  const showLink = ()=>{
    const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
    global.g_newCardTitle = text;

    let link = editor.getAttributes('link').href

    //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
    editor.commands.blur();

    window.showDialogLink(link, 'card', (item) => {
      if(!item) {
        editor.commands.unsetLink()
        return;
      };

      if (isString(item.link)){
        if(!item.link?.startsWith("http") && item.link?.includes(".")){
          item.link=`https://${item.link}`
        }
      }


      if (item.delete) {
        editor.commands.unsetLink()
      } else {
        editor.commands.setLink({href: item, target: '_blank'})
        setTimeout(() => {
          window.hookATags();
        }, 600)
      }
    })
  }

  return (
      <>
        <div className={`tiptap-outer-sider-div-for-test-click default-font-family ${style.EditorStyle} ${fullScreen ? null : style.modal + ' inModal'}`}
             id="NODE_EDITOR_EL"
             style={{
               position:'relative',//imageAction的计算位置需要!!!!
               paddingTop: getPaddingTop(),
               height:getHeight(),
               // overflowX:'auto',
               // overflowY:'auto',
               // paddingLeft: getPadding(),
               // paddingRight: getPadding(),
               // height:modalHeight+'px',
             }}
             onContextMenu={rightClick}
             onClick={onClick}>
          {
              editor && !isPdfAtom && (
                  <BubbleMenu editor={editor}
                              shouldShow={()=> {
                                if (!editorRef.current)return false;
                                if (Global.g_isPresentMode)return false;
                                if (global.g_isFromHeadClicked) {
                                  global.g_isFromHeadClicked = false;
                                  return false;
                                }
                                const {from,to} = editorRef.current.state.selection;
                                let szName = editorRef.current.state.selection.node?.type?.name;
                                if ('deeplink' == szName || 'youtube' == szName || 'latexBlock' == szName)return false;
                                if (to != from) {
                                  return true;
                                }
                                return false;
                              }}
                              tippyOptions={{duration: 200, hideOnClick: true,maxWidth:'700px'}}>
                    <div className={style.action} style={{display: isShowTextBar ? 'grid' : 'none'}}>
                      <Dropdown overlayStyle={{zIndex: MAX_Z_INDEX}} menu={{
                        items: [
                          {
                            label: t('Text'),
                            key: ''
                          }, {
                            label: t('H1'),
                            key: 1
                          }, {
                            label: t('H2'),
                            key: 2
                          }, {
                            label: t('H3'),
                            key: 3
                          }, {
                            label: t('H4'),
                            key: 4
                          }, {
                            label: t('H5'),
                            key: 5
                          }, {
                            label: t('H6'),
                            key: 6
                          }, {
                            label: t('Todo'),
                            key: 7
                          }, {
                            label: t('Number list'),
                            key: 8
                          }, {
                            label: t('Bullet list'),
                            key: 9
                          }
                        ], async onClick(event) {
                          const e = Number(event.key)
                          // 判断当前是不是list节点 转文本
                          const {from} = editor.state.selection
                          const resolvedPos = editor.state.doc.resolve(from);
                          const currentNode = resolvedPos.node();
                          const parentNode = resolvedPos.node(resolvedPos.depth - 1);

                          // debugger
                          if ([1, 2, 3, 4, 5, 6].includes(e)) {
                            editor.chain().focus().setHeading({level: e,id:generateUUID2()}).run()
                          } else if (e === 7 && parentNode.type.name !== 'taskItem') {
                            editor
                                .chain()
                                .focus()
                                .toggleTaskList()
                                .run()
                          } else if (e === 8 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'orderedList')) {
                            // 如果是自己类型地list转过来需要检验 不通过
                            // 如果是非自己类型地list转过来需要检验 通过
                            // 如果是非list 通过
                            editor
                                .chain()
                                .focus()
                                .toggleOrderedList()
                                .run()
                          } else if (e === 9 && !(parentNode.type.name === 'listItem' && resolvedPos.depth - 2 > -1 && resolvedPos.node(resolvedPos.depth - 2).type.name === 'bulletList')) {
                            editor
                                .chain()
                                .focus()
                                .toggleBulletList()
                                .run()
                          } else if (e === 0) {
                            if (parentNode.type.name === 'listItem' || parentNode.type.name === 'taskItem') {
                              const grandNode = resolvedPos.node(resolvedPos.depth - 2);
                              if (grandNode.type.name === 'orderedList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleOrderedList()
                                    .run()
                              } else if (grandNode.type.name === 'bulletList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleBulletList()
                                    .run()
                              } else if (grandNode.type.name === 'taskList') {
                                editor
                                    .chain()
                                    .focus()
                                    .toggleTaskList()
                                    .run()
                              }

                            } else {
                              editor.chain().focus().setParagraph().run()
                            }
                          }
                        }
                      }}>
                        <div className='flex-row-vertical-center' style={{
                          marginLeft: '0px',
                          paddingLeft: '6px',
                          width: '100%',
                          whiteSpace: 'nowrap'
                        }}>
                  <span>
                    {editor.isActive('heading', {level: 1}) ? 'H1' :
                        editor.isActive('heading', {level: 2}) ? 'H2' :
                            editor.isActive('heading', {level: 3}) ? 'H3' :
                                editor.isActive('heading', {level: 4}) ? 'H4' :
                                    editor.isActive('heading', {level: 5}) ? 'H5' :
                                        editor.isActive('heading', {level: 6}) ? 'H6' :
                                            editor.isActive('bulletList') ? t('Bullet list'):
                                                editor.isActive('orderedList') ? t('Number list'):
                                                    editor.isActive('taskList') ? t('Todo') : t('Text')
                    }
                  </span>
                          <img className='img-28' style={{marginTop: '-2px'}}
                               src={getImagePathWithTheme('note_tool_dropdown')}/>

                        </div>
                      </Dropdown>

                      <div className={'line-card-h-split'}></div>

                      <div
                          className={editor.isActive("bold") ? style.act : null}
                          onClick={() => editor.chain().focus().toggleBold().run()}
                          title={t("Bold")}
                      >
                        {/*<TextBold theme="outline" size="16" fill="#333" />*/}
                        <img className='img-28'
                             src={getImagePathWithTheme('note_tool_bold' + (editor.isActive("bold") ? '_selected' : ''))}/>
                      </div>
                      <div
                          className={editor.isActive("italic") ? style.act : null}
                          onClick={() => editor.chain().focus().toggleItalic().run()}
                          title={t("Italic")}
                      >
                        {/*<TextItalic theme="outline" size="16" fill="#333" />*/}
                        <img className='img-28'
                             src={getImagePathWithTheme('note_tool_italic' + (editor.isActive("italic") ? '_selected' : ''))}/>
                      </div>
                      <div
                          className={editor.isActive("underline") ? style.act : null}
                          onClick={() => editor.chain().focus().toggleUnderline().run()}
                          title={t("Underline")}
                      >
                        {/*<TextUnderline theme="outline" size="16" fill="#333" />*/}
                        <img className='img-28'
                             src={getImagePathWithTheme('note_tool_underline' + (editor.isActive("underline") ? '_selected' : ''))}/>
                      </div>
                      <div
                          className={editor.isActive("strike") ? style.act : null}
                          onClick={() => editor.chain().focus().toggleStrike().run()}
                          title={t("Strokethrough")}
                      >
                        {/*<Strikethrough theme="outline" size="16" fill="#333"/>*/}
                        <img className='img-28'
                             src={getImagePathWithTheme('note_tool_strikethrough' + (editor.isActive("strike") ? '_selected' : ''))}/>
                      </div>
                      <div
                          className={
                            editor.isActive({textAlign: "center"}) ? style.act : null
                          }
                          onClick={() =>
                              editor.isActive({textAlign: "center"})
                                  ? editor.chain().focus().setTextAlign("left").run()
                                  : editor.chain().focus().setTextAlign("center").run()
                          }
                          title={t("Align")}
                      >
                        {/*<AlignTextCenter theme="outline" size="16" fill="#333" />*/}
                        <img className='img-28'
                             src={getImagePathWithTheme('note_tool_align' + (editor.isActive({textAlign: "center"}) ? '_selected' : ''))}/>
                      </div>

                      <div
                          className={editor.isActive('code') ? style.act : null}
                          onClick={() => {
                            editor.chain().focus().toggleCode().run()
                          }}
                          title={t("InlineCode")}
                      >
                        <img className='img-28'
                             src={editor.isActive('code')?getImagePathWithSvg('node_tool_code_block_selected'):getImagePathWithThemeSvg('node_tool_code_block')}/>
                      </div>

                      <div className={'line-card-h-split'}></div>

                      <InputNumberExt value={currentFontSize} onValueChanged={(value)=>{
                        editor.chain().focus().setFontSize(`${value}px`).run();
                      }}/>

                      <div className={'flex-row-vertical-center'} style={{margin: '0 9px 0 14px', display: 'flex'}}>
                        <ColorPickers editor={editor}/>
                      </div>

                      {
                        !isInSingleFloatWindow() &&
                          <>
                            <div className={'line-card-h-split'}></div>
                            <div
                                className={
                                  editor.getAttributes('link').href ? style.act : null
                                }
                                onClick={() => {
                                  showLink();
                                }}>
                              {/*<LinkIcon theme="outline" size="16" fill="#333" />*/}
                              <img className='img-20'
                                   src={getImagePathWithTheme('card_bubble_menu_link' + (editor.getAttributes('link').href ? '_selected' : ''))}/>
                            </div>

                            <div className={'line-card-h-split'}></div>
                            <div style={{
                              margin: '0 6px 0 0',
                              display: 'flex',
                              width: '100%',
                              cursor: 'pointer',
                              paddingRight: '0px'
                            }}>
                              <TurnNewCard editor={editor}/>
                            </div>
                            <div className={'line-card-h-split'}></div>

                            <div style={{margin: '0 4px', display: 'flex', width: '100%', cursor: 'pointer'}}>
                              <HighlightPicker editor={editor} data={props.data}/>
                            </div>
                          </>
                      }
                    </div>
                  </BubbleMenu>
              )}

          {
            !draw ?
                <textarea id={`NOTE_TITLE_INPUT-${props.data?.id}`} autoFocus={true} ref={txtTitleRef}
                          disabled={props.from == FROM_JOURNAL || props.data?.type == 'journal' || props.from == FROM_SHARE_CARD}
                          placeholder={props.from == FROM_JOURNAL ? `` : t("Untitled")}
                          value={props.data?.type == 'journal' ? getJournalName(props.data.journalTime) : (title == t("Untitled") ? '' : title)}
                          onPaste={(event)=>{
                            // let pasteText = (event.clipboardData.getData('text/plain'));
                            // pasteText = pasteText.replaceAll('\n','');
                            //
                            // event.preventDefault();
                            // setTitle(pasteText);
                            //
                            // props.data.name = pasteText;

                            setTimeout(()=>{
                              const newTitle = txtTitleRef.current.value.replaceAll('\n','');
                              setTitle(newTitle);
                              props.data.name = newTitle;

                              txtTitleRef.current.style.height = '0px';
                              txtTitleRef.current.style.height = `${txtTitleRef.current.scrollHeight}px`

                              syncUpdate().then(res => {
                                if (isInPageCard()) {
                                  postMessage(EVENT_REFRESH_RECENTS);
                                }
                                if (isInDraw()){
                                  postMessage(EVENT_RENAME_LIBRARY_ITEM,{...props.data})
                                }
                                if (props.data.isFavirated){
                                  postMessage(EVENT_FAVIRIATE_CHANGE);
                                }
                              });
                            },10)
                          }}
                          onInput={(e) => {
                            if (props.from == FROM_JOURNAL) return;

                            setTitle(e.target.value)
                            props.data.name = e.target.value;
                            if (window.refreshRightSliderTitle){
                              window.refreshRightSliderTitle(e.target.value)
                            }
                            window.globalRefreshList('refreshSelfCard_',props.data,{selfUUID:uuid.current});
                            window.globalRefreshList('refresh_canvas_deeplink_card_title_',{id:props.data.id,name:props.data.name})
                            setTimeout(() => {
                              // global.g_isRefreshLibraryInfoLink = true;//刷新标题的话，要刷新info
                              txtTitleRef.current.style.height = '0px';
                              txtTitleRef.current.style.height = `${txtTitleRef.current.scrollHeight}px`
                              syncUpdate().then(res => {
                                if (isInPageCard()) {
                                  postMessage(EVENT_REFRESH_RECENTS);
                                }
                                if (isInDraw()){
                                  postMessage(EVENT_RENAME_LIBRARY_ITEM,{...props.data})
                                }
                                if (props.data.isFavirated){
                                postMessage(EVENT_FAVIRIATE_CHANGE);
                              }
                            });

                    //刷新DEEPLINK标题
                    postMessage(EVENT_REFRESH_DEEPLINK_TITLE,{data:props.data});
                  }, 10)
                }}
                          onFocus={(e)=>{
                            if (editorRef.current) {
                              editorRef.current.chain().setTextSelection(editorRef.current.state.selection.from).run();
                            }
                          }}
                          onBlur={()=>{
                  // renameCardById(props.data?.id,title)
                }} className={style.titleInput}
                          style={{
                                color: 'var(--text-color)',
                                display: (hasTitleEmpty) ? 'none' : 'inherit',
                                overflow: 'hidden',
                                margin:'0 7px',
                              }} onKeyDown={(e) => {
                  isEdited = 2
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    editor.commands.insertContentAt(0, {
                      type: 'paragraph',
                      content: [],
                    });
                    editor.commands.focus()
                  }else if (e.keyCode == 8) {
                    //返回
                    if (e.currentTarget.value == '') {
                      setHasTitleEmpty(true);
                      editorRef.current.commands.focus();
                      //更新，无标题..
                      props.data.hasTitle = false;
                      syncUpdate().then(res => {
                        if (isInPageCard()) {
                          postMessage(EVENT_REFRESH_RECENTS);
                        }
                        if (isInDraw()) {
                          postMessage(EVENT_RENAME_LIBRARY_ITEM, {...props.data})
                        }
                        if (props.data.isFavirated) {
                          postMessage(EVENT_FAVIRIATE_CHANGE);
                        }
                      });
                    }
                  }
                }}/> :
                <div className={style.titleInput}>{title}</div>
          }
          <div ref={divTitleRef} style={{
            display: hasTitleEmpty ? 'none' : 'inherit'
          }} className={style.titleInput2}
               id='NOTE_TITLE_INPUT2'>{title}</div>

          {
            //配色真是随便,每个设计一个样。。。。。
              props.data?.type == 'journal' &&
              <span className={'font-family-regular journal-title'}
                    style={{color: 'var(--primary-color)', display: 'block',marginBottom:'6px',marginLeft:'20px',marginTop:'12px'}}>{t(MAP_WEEK_FULL[`${(new Date(props.data.journalTime || '').getDay())}`])}</span>
          }

          {
              !isInSingleFloatWindow() &&
              <div style={{height: hasTitleEmpty ? '30px' : '16px'}}></div>
          }

          {/*2个地方的overflow 影响内嵌的公式弹窗 包括样式.ProseMirror中的overflow先取消*/}

          <EditorContent className="tableStyle"
                         ref={editorContentRef}
                         style={{
                           // padding: '6px 28px',
                           // overflowY:'hidden',
                           height:props.from == FROM_JOURNAL?'auto':"auto",
                           marginLeft:marginJournal,
                           paddingLeft:paddingJournal,
                           marginRight:marginJournal,
                           paddingRight:paddingJournal
                         }}
                         editor={editor}/>
          {/*<LinkPage/>*/}
          <SearchBox/>
          <ImgAction editor={editor}/>
          <CountWords/>

          {
            // isShowLink &&
            // <div style={{
            //   position: 'absolute',
            //   zIndex: '2004',
            //   width: '260px',
            //   height: '32px',
            //   background: '#11000033',
            //   left: linkPosition.left,
            //   top: linkPosition.top
            // }}>
            //
            // </div>
          }

          {/*info info info */}
          {
            isInfoVisible() && !isInSingleFloatWindow() &&
            <div id="editorBottom" style={{
              paddingBottom: '38px',
              marginTop: '60px',
              marginLeft:'12px',
              marginRight:'12px',
            }}>
              {
                  !isExpandInfo &&
                  <div style={{height: '1px', background: 'var(--line-color)', marginTop: '12px',}}></div>
              }
              <div className={'flex-row-vertical-center mt-6 cursor-pointer'} onClick={() => {
                setIsExpandInfo(!isExpandInfo);
                if (!isExpandInfo) {
                  let createTime = props.data.createTime;
                  let updateTime = Date.now();
                  if (!createTime) {
                    createTime = updateTime;
                  }

                  setTimeout(() => {
                    props.data.type = 'card';
                    props.data.createTime = createTime;
                    props.data.updateTime = updateTime;

                    libraryInfoRef.current?.onShowDialog('library', props.data, false);
                  }, 100)
                }
              }}>
                <img className={'img-14'}
                     style={{transform: isExpandInfo ? 'rotate(0deg)' : 'rotate(-90deg)'}}
                     src={getImagePathWithTheme(isExpandInfo ? 'arraw_down_small' : 'arraw_down_small_gray')}/>
                <span className={'ml-4'} style={{
                  marginTop: '1px',
                  color: isExpandInfo ? 'var(--text-color)' : (isDarkMode() ? '#888888' : 'var(--line-color)')
                }}>{t("Info")}</span>
              </div>
              {
                  isExpandInfo &&
                  <div style={{height: '1px', background: 'var(--line-color)', marginTop: '12px',}}></div>
              }

              {
                // isExpandInfo &&
                <div style={{
                  overflow: 'hidden',//有线，要显示....
                  display: isExpandInfo ? 'inherit' : 'none',
                  paddingLeft:'16px',
                  paddingRight:'16px'
                }}>
                  <LibraryInfos ref={libraryInfoRef} from={'EditorBottom'} height={modalHeight * 0.4 - 40}/>
                </div>
              }
            </div>
          }

        </div>
        {!!editor && !isPdfAtom && fullScreen && !isInSingleFloatWindow() &&<SideBarFold ref={sideBarRef} onCollapseCallback={(sideBarStatus0:any)=>{
          if (sideBarStatus.current != undefined){
            sideBarStatus.current = sideBarStatus0;
          }
        }}/>}

      </>
  );
});

export default Editor;
